import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
import { ref } from 'vue';
import BigNumber from 'bignumber.js';
export const useStaking = () => {
    const isLoading = ref(false);
    const isPostFaild = ref(false);
    const _error = (err) => Promise.reject(err);
    /**
     * @return Currency Lists
     * @param null
     */
    const getStakingCurrencyLists = () => __awaiter(void 0, void 0, void 0, function* () {
        const url = '/crypto-staking-currencies';
        return yield ApiManager.get(url).catch(_error);
    });
    const getStakingCurrencyListsUnlogin = () => __awaiter(void 0, void 0, void 0, function* () {
        const url = '/crypto-staking-currencies-unlogin';
        return yield ApiManager.get(url).catch(_error);
    });
    /**
     * @return Plan Lists By Currency
     * @param currencyId number
     */
    const getStakingPlanListsByCurrency = (currencyId) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/crypto-staking-per-currencies?currency_id=${currencyId}`;
        return yield ApiManager.get(url).catch(_error);
    });
    const getStakingPlanListsByCurrencyUnlogin = (currencyId) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/crypto-staking-per-currencies-unlogin?currency_id=${currencyId}`;
        return yield ApiManager.get(url).catch(_error);
    });
    /**
     * @return Plan Lists By Term/Lock in Period and currency_id
     * @param currencyId number
     * @param cryptoName string
     * @param term number
     * @return StakingAmountListsModel
     */
    const getStakingPlanListsByTerm = (currencyId, cryptoName, term) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/crypto-staking-plan-per-term?currency_id=${currencyId}&cryptoName=${cryptoName}&term=${term}`;
        return yield ApiManager.get(url).catch(_error);
    });
    const getStakingPlanListsByTermUnlogin = (currencyId, cryptoName, term) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/crypto-staking-plan-per-term-unlogin?currency_id=${currencyId}&cryptoName=${cryptoName}&term=${term}`;
        return yield ApiManager.get(url).catch(_error);
    });
    /**
     * get the specific plan from plan list
     * @param amount number
     * @param plans StakingBoundary[]
     * @return StakingBoundary
     */
    const getPlanFromList = (amount, plans) => {
        const filteredPlan = plans.filter((plan) => plan.boundaryAmount <= amount);
        const maxBoundaryAmount = filteredPlan
            .map((plan) => plan.boundaryAmount)
            .reduce((before, current) => Math.max(before, current));
        const destinatePlan = filteredPlan.find((plan) => plan.boundaryAmount === maxBoundaryAmount);
        return destinatePlan || plans[0];
    };
    /**
     * returns calculated interest for ui only (not included in save)
     * @param amount number
     * @param interestRate number
     * @param term number
     * @param dp number
     * @returns number
     */
    const calculateInterest = (amount, interestRate, term, dp) => {
        const PERCENTAGE = 100;
        const YEAR_DAYS = 365;
        return BigNumber(interestRate)
            .div(PERCENTAGE)
            .div(YEAR_DAYS)
            .multipliedBy(amount)
            .multipliedBy(term)
            .toFixed(dp, BigNumber.ROUND_FLOOR);
    };
    /**
     * @summary currencies
     * @param currencies
     */
    const getStakingCurrencies = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isLoading.value = true;
            return yield ApiManager.get('/crypto-staking');
        }
        catch (err) {
            isPostFaild.value = true;
            throw err;
        }
        finally {
            isLoading.value = false;
        }
    });
    /**
     * @summary add stake
     * @param stakingPlanID
     * @param memberID
     * @param amount
     */
    const postStake = (staking_plan_id, member_id, amount) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const request = {
                staking_plan_id,
                member_id,
                amount,
            };
            return yield ApiManager.post('/crypto-staking', request);
        }
        catch (err) {
            // throw err as Error;
            throw err.response.data.message;
        }
    });
    /**
     * @summary dummy currencies
     * @param currencies
     */
    const getStakingList = () => __awaiter(void 0, void 0, void 0, function* () {
        return {
            BTC: [
                {
                    id: 1000007,
                    symbol: 'btc',
                    currency_name: 'Bitcoin',
                    description: 'Bitcoin',
                    calculation_decimal_part: 8,
                    annual_interest_rate: 1,
                    lock_in_period: 30,
                    min_stake: 1,
                    max_stake: 10,
                },
                {
                    id: 1000009,
                    symbol: 'btc',
                    currency_name: 'Bitcoin',
                    description: 'Bitcoin',
                    calculation_decimal_part: 8,
                    annual_interest_rate: 2,
                    lock_in_period: 30,
                    min_stake: 1,
                    max_stake: 20,
                },
            ],
            USDT: [
                {
                    id: 1000001,
                    symbol: 'usdt',
                    currency_name: 'US Dollar',
                    description: 'US Dollars',
                    calculation_decimal_part: 4,
                    annual_interest_rate: 12,
                    lock_in_period: 30,
                    min_stake: 1,
                    max_stake: 12,
                },
                {
                    id: 1000002,
                    symbol: 'usdt',
                    currency_name: 'US Dollar',
                    description: 'US Dollars',
                    calculation_decimal_part: 4,
                    annual_interest_rate: 1,
                    lock_in_period: 30,
                    min_stake: 1,
                    max_stake: 10,
                },
            ],
            BBC: [
                {
                    id: 1000004,
                    symbol: 'bbc',
                    currency_name: 'BBC',
                    description: 'BBC',
                    calculation_decimal_part: 6,
                    annual_interest_rate: 13,
                    lock_in_period: 30,
                    min_stake: 1,
                    max_stake: 11,
                },
                {
                    id: 1000006,
                    symbol: 'bbc',
                    currency_name: 'BBC',
                    description: 'BBC',
                    calculation_decimal_part: 6,
                    annual_interest_rate: 1,
                    lock_in_period: 30,
                    min_stake: 1,
                    max_stake: 10,
                },
            ],
        };
    });
    /**
     * @summary dummy crypto list
     * @param null
     */
    const getCryptoList = () => __awaiter(void 0, void 0, void 0, function* () {
        return [
            {
                cryptoName: 'btc',
                interestRate: 2,
            },
            {
                cryptoName: 'usdt',
                interestRate: 5,
            },
            {
                cryptoName: 'bbc',
                interestRate: 10,
            },
        ];
    });
    /**
     * @summary dummy plan list
     * @param null
     */
    const getPlanList = () => __awaiter(void 0, void 0, void 0, function* () {
        return [
            {
                term: 1,
                maxInterestRate: 0.5,
                minInterestRate: 0.5,
            },
            {
                term: 30,
                maxInterestRate: 2.0,
                minInterestRate: 1.0,
            },
            {
                term: 90,
                maxInterestRate: 10.0,
                minInterestRate: 5.0,
            },
        ];
    });
    /**
     * @summary dummy plan list
     * @param null
     */
    const getPlanDetailsList = () => __awaiter(void 0, void 0, void 0, function* () {
        return {
            term: '30',
            minStake: 0.001,
            maxStake: 10.1001,
            step: 1,
            calculationDecimalPart: 16,
            boundary: [
                {
                    id: 3,
                    term: 30,
                    annualInterestRate: 2,
                    boundaryAmount: 4.0,
                },
                {
                    id: 4,
                    term: 30,
                    annualInterestRate: 1,
                    boundaryAmount: 2.0,
                },
            ],
        };
    });
    return {
        isPostFaild,
        isLoading,
        getStakingCurrencies,
        getStakingList,
        postStake,
        getCryptoList,
        getPlanList,
        getPlanDetailsList,
        getStakingCurrencyLists,
        getStakingCurrencyListsUnlogin,
        getStakingPlanListsByCurrency,
        getStakingPlanListsByCurrencyUnlogin,
        getStakingPlanListsByTerm,
        getStakingPlanListsByTermUnlogin,
        getPlanFromList,
        calculateInterest,
    };
};
